// extracted by mini-css-extract-plugin
export default {"wrap":"checklist-item_wrap__nlvpg","editing":"checklist-item_editing__SyKv2","checked":"checklist-item_checked__EPxoc","text":"checklist-item_text__bnUhE"};